import React from 'react';
import { useTranslation } from 'react-i18next';

// components
import Dialog from '@mui/material/Dialog';
import { PaperProps } from '@mui/material/Paper';

// styles
import * as Buttons from 'theme/components/Buttons.style';
import * as Cards from 'theme/components/Cards.style';
import * as Text from 'theme/components/Text.style';

interface DemoDialogProps {
  closeModal: () => void;
  isOpenConfirmDialog: boolean;
}

// Create a wrapper component that accepts PaperProps
function StyledPaperBase(
  props: PaperProps,
  ref: React.ForwardedRef<HTMLDivElement>
) {
  // Strip Paper-only props so we don't leak invalid DOM attributes onto a div
  const other = { ...(props as any) };
  delete other.elevation;
  delete other.square;
  delete other.variant;

  return <Cards.BaseCard ref={ref as any} {...other} />;
}

const StyledPaper = React.forwardRef<HTMLDivElement, PaperProps>(
  StyledPaperBase
);

const DemoDialog: React.FC<DemoDialogProps> = ({
  closeModal,
  isOpenConfirmDialog,
}) => {
  const { t } = useTranslation('pageEcoach');

  return (
    <Dialog
      onClose={closeModal}
      open={isOpenConfirmDialog}
      PaperComponent={StyledPaper}
    >
      <Text.P2>{t('allChats.DemoDialog.message')}</Text.P2>
      <Buttons.Primary
        as="a"
        href="https://meetings.hubspot.com/justin-lessard-wajcer"
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('allChats.DemoDialog.Book a call')}
      </Buttons.Primary>
    </Dialog>
  );
};

export default DemoDialog;
